export const getOtherUserProfileState = user_id => state => state.otherUser.otherUserProfileStates[user_id];

export const getOtherUserProfile = state => state.otherUser.otherUserProfile;
